// Import Core
import React, { useState } from 'react';
import styled from 'styled-components';
// Import Components
import Button from '../ui/buttons/Button';
import { toSlug } from '../../utils/search/toSlug';

/* Styled Components */
const TableBlockStyles = styled.section`
display: flex;
	flex-direction: column;
	gap: 24px;
	width: 100%;
  height: 100%;
  position: relative;
  @media (max-width: 992px) {
    gap: 20px;
    &::-webkit-scrollbar {
      display: none;  //for Chrome, Safari and Opera
    }
    /* -ms-overflow-style: none;  // IE and Edge */
    /* scrollbar-width: none;  // Firefox */
  }
  .section-title {
    #caption {
      padding-top: 24px;
      @media (max-width: 992px) {
        padding-top: 20px;
      }
    }
  }
	#table {
		border-collapse: collapse;
		width: 100%;
		thead {
			width: 100%;
			border: 1px solid var(--neutral-25);
      @media (max-width: 992px) {
        display: none;
      }
			tr {
        width: 100%;
				border-bottom: 1px solid var(--neutral-25);
				th {
          padding: 10px 24px;
					text-align: left;
          @media (max-width: 992px) {
            &:first-child, &:nth-child(3), &:nth-child(5) {
            display: none;
            }
            padding: 8px 20px;
          }
          .title {
						text-transform: uppercase;
            font-family: var(--font-family-heading);
					}
				}
			}
		}
		tbody {
      &.expand {
        tr.hidden {
          display: table-row;
        }
      }
			tr {
				border: 1px solid var(--neutral-25);
				@media (max-width: 992px) {
					border: none;
				}
        &.hidden {
          display: none;
        }
				td {
					border-bottom: 1px solid var(--neutral-25);
					height: 56px;
					padding: 16px;
					overflow: hidden;
					color: var(--black);
					text-overflow: ellipsis;
					@media (max-width: 992px) {
						border-left: 1px solid var(--neutral-25);
						border-right: 1px solid var(--neutral-25);
            display: flex;
            align-items: center;
            height: unset;
            padding: 10px 24px;
            gap: 24px;
					}
					.mobile-title {
						display: none;
						text-transform: uppercase;
            font-family: var(--font-family-heading);
						color: var(--black);
						@media (max-width: 992px) {
              display: block;
              flex: 1;
						}
					}
          span {
            @media (max-width: 992px) {
              flex: 1;
            }
          }
					&:first-child {
						.mobile-title {
							@media (max-width: 992px) {
								display: none;
							}
						}
					}
					@media (max-width: 992px) {
						&:first-child {
							border-top: 1px solid var(--grey-25);
						}
					}
				}
			}
		}
	}
`;

const renderTableHeader = (table) => {
  return (
    table.rows[0].cells.map((title, i) => {
      return (
        <th key={i}>
          <h5 className='title'>{title}</h5>
        </th>
      );
    })
  );
};
const renderTableData = (tableData, tableColumns) => {
  return (
    tableData &&
    tableData.map((row, i) => {
      // index of 3 + 1 to account for hidden headings row
      const hiddenClass = i >= 4 ? 'hidden ' : '';
      if (i > 0) {
        return (
          <tr className={hiddenClass + "pin-table"} key={i}>
            {row.cells.map((item, index) => {
              return (
                <td key={index}>
                  <h5 className='mobile-title'>{tableColumns[index]}</h5>
                  <span>{item}</span>
                </td>
              );
            })}
          </tr>
        );
      }
    })
  );
};

/* Render Component */
const TableBlock = ({ addToAnchor, tableTitle, tableCaption, addTableHeaders, table }) => {
  const [isTableExpanded, setIsTableExpanded] = useState(false);

  const tableColumns = table.rows[0].cells
  const tableData = table.rows;

  return (
    <TableBlockStyles id={addToAnchor ? `anchor_${toSlug(tableTitle)}` : ''} className={`${addToAnchor && 'anchor-link'}`}>
      <div className='section-title'>
        <h3 id='title'>{tableTitle}</h3>
        {tableCaption &&
          <p id='caption'>{tableCaption}</p>
        }
      </div>

      <table id='table'>
        {addTableHeaders &&
          <thead>
            <tr>
              {renderTableHeader(table)}
              <th></th>
            </tr>
          </thead>
        }
        <tbody className={`${isTableExpanded ? 'expand' : ''}`}>{renderTableData(tableData, tableColumns)}</tbody>
      </table>

      {(table.rows.length > 3) &&
        <Button
          size='md'
          btnStyle='outline'
          value={isTableExpanded ? 'SHOW LESS' : 'SHOW MORE'}
          clickHandler={() => {
            setIsTableExpanded(!isTableExpanded);
          }}
          isDisabled={false}
        />
      }
    </TableBlockStyles>
  );
};

export default TableBlock;
